import { hashString } from 'lib/helpers';

export function hashObject(obj) {
	if (obj.prototype) {
		throw new RangeError('Can only hash a plain object');
	}
	return hashString(JSON.stringify(obj));
}



// WEBPACK FOOTER //
// ./lib/helpers/hashObject.js